module.exports = __webpack_public_path__ + "img/06_SAN PEDRO JUVENIL (O.insignis).3f15d3f7.png";